import { useAdvisoryReport } from '../../../api/getAdvisoryReport';
import useAdvisoryReportCreationParams from './useCreationFlowSubject';

const useCreationFlowReport = () => {
  const { reportId } = useAdvisoryReportCreationParams();
  return useAdvisoryReport(reportId);
};

export default useCreationFlowReport;
